import { useTheme } from "@mui/material/styles";

import MuiAppBar, { type AppBarProps } from "@mui/material/AppBar";
import MuiToolbar, { type ToolbarProps } from "@mui/material/Toolbar";


AppBar.Toolbar = (props: ToolbarProps) => {
	const theme = useTheme();
	const style = {
		root: {
			justifyContent: "space-between",
			gap: { xs: 1.25, sm: 3.75 },
			p: theme.spacing(1, 2)
		}
	};

	return <MuiToolbar {...props} sx={{ ...style.root, ...props.sx }} />;
};

export default function AppBar(props: AppBarProps) {
	return <MuiAppBar {...props} />;
}